module.exports = __webpack_public_path__ + "img/check-icon.a7d6f0d3.svg";